export enum ForkliftHardwareType {
  VCU = 0,
  ECU = 1,
}

/**
 * 叉车固件相关的 IAM 权限点（p_id）。
 * 迁移自原 dingding_permission 表的 4 个中文权限枚举，
 * 现统一由 IAM 管理，p_id 遵循 `ota:forklift:*` 约定。
 *
 * 旧值（dingding_permission 枚举）→ 新 p_id 映射：
 *   变动抄送      → ota:forklift:carbon_copy
 *   固件审核      → ota:forklift:auditor
 *   信息维护      → ota:forklift:info_edit
 *   测试中心审核  → ota:forklift:test_center
 */
export const FirmwarePermission = {
  // 变动抄送
  CARBON_COPY: 'ota:forklift:carbon_copy',
  // 固件审核
  AUDITOR: 'ota:forklift:auditor',
  // 信息维护 -- 图号/固件
  INFO_EDIT: 'ota:forklift:info_edit',
  // 测试中心审核
  TEST_CENTER: 'ota:forklift:test_center',
} as const;

export type FirmwarePermission =
  (typeof FirmwarePermission)[keyof typeof FirmwarePermission];

export enum AuditStatus {
  // 草稿：上传后默认状态，可改可删，不进入审核流程
  DRAFT = 'DRAFT',

  // 新增待审核
  PENDING = 'PENDING',
  // 新增审核通过
  PASS = 'PASS',
  // 新增审核不通过
  REJECT = 'REJECT',

  // 新增审核通知发送失败
  CREATE_AUDIT_FAIL = 'CREATE_AUDIT_FAIL',

  // 测试中心待审核
  TEST_CENTER_PENDING = 'TEST_CENTER_PENDING',
  // 测试中心审核通过
  TEST_CENTER_PASS = 'TEST_CENTER_PASS',
  // 测试中心审核不通过
  TEST_CENTER_REJECT = 'TEST_CENTER_REJECT',

  // 测试中心审核通知发送失败
  TEST_CENTER_CREATE_AUDIT_FAIL = 'TEST_CENTER_CREATE_AUDIT_FAIL',

  // 变动待审核
  CHANGE_PENDING = 'CHANGE_PENDING',
  // 变动审核通过
  CHANGE_PASS = 'CHANGE_PASS',
  // 变动审核不通过
  CHANGE_REJECT = 'CHANGE_REJECT',

  // 变动审核通知发送失败
  CHANGE_AUDIT_FAIL = 'CHANGE_AUDIT_FAIL',
}

export enum ForkliftFirmwareType {
  // 主核
  MASTER = 'MASTER',
  // 副核
  VICE = 'VICE',
}

// 补测任务状态：测试中心审批通过后自动生成「待确认」，由测试中心确认是否需要补测
export enum RetestTaskStatus {
  // 待确认：固件刚发布，等待测试中心确认是否需要补测
  WAIT_CONFIRM = 'WAIT_CONFIRM',
  // 无需补测
  NO_RETEST = 'NO_RETEST',
  // 待补测：已确认需要补测
  PENDING = 'PENDING',
  // 测试结束：补测完成（结论与报告见任务记录）
  DONE = 'DONE',
}

// 测试结论：补测闭环时由测试中心选择，随报告一并记录
export enum RetestConclusion {
  // 通过
  PASS = 'PASS',
  // 不通过
  FAIL = 'FAIL',
}

// 固件特殊发布标记（由补测任务状态联动映射）
export enum SpecialReleaseStatus {
  // 无标记
  NONE = 'NONE',
  // 特殊发布，待补测
  PENDING = 'PENDING',
  // 特殊发布，补测通过
  PASS = 'PASS',
  // 特殊发布，补测不通过
  FAIL = 'FAIL',
}
